import React, {Component} from 'react'
import PropTypes from "prop-types";
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import PatientChart from "../../views/doctor/PatientChart";


class Patient_Page_TreatmentResponse extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    async componentDidMount() {

    }


    render() {

        let{t,isExpanded,showDemo} =this.props


   /*     let Targetseries=[{
            name: 'Pain',
            data: [1,2,4,7,3,1]
        }, {name: 'Loss of appetite',
            data: [3,1,4,0,1,1]
        }]
*/

        let Targetseries= [{
            name: 'Pain',
            type: 'line',
            data: [10,10,10,10,8,8,7,6, 5, 5, 8, 6, 6, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3]
        },{
            name: 'Loss of appetite',
            type: 'line',
            data: [8, 9, 9, 8, 8, 7, 7, 7, 6, 6, 6, 6, 8, 6, 6, 9, 6, 6, 5, 5, 5, 5, 7, 5, 5, 5, 5, 4, 4, 4]
        }]

        let SideEffectSeries= [{
            name: 'Anxiety',
            type: 'bar',
            data: [5, 5, 2, 2, 1, 0]
        },{
            name: 'Dizziness',
            type: 'bar',
            data: [4, 5, 3, 1, 1, 0]
        }]

        let categories=["1-Oct","","","","6-Oct","","","","","11-Oct","","","","16-Oct","","","","21-Oct","","","","26-Oct","","","","31-Oct","","","",""]
        let categories2=["1-Oct","6-Oct","11-Oct","16-Oct","21-Oct","26-Oct","31-Oct"]


        return (
            isExpanded?(
                <div className={'formBoxes_patientPage'}>

                <div style={{display:'flex'}}>
                    <div className={'Impression_block'}>
                        <div className={'graph_label'}>{t('patientPage.Patient_Impression')}</div>
                    <div className={'Impression_subBlock'}>
                        <div className={'Impression_title'}> {t('patientPage.No_Change')}</div>
                        {showDemo&&<div className={"slidecontainer"}>
                            <input type="range" min="1" max="7" value="4" className="slider" id="myRange"/>
                        </div>}
                    </div>
                    </div>
                    <div className={'Patient_Graph'}>
                        <div style={{display:'flex'}}>
                            <label className={'graph_label'}>{t('patientPage.Target_Symptoms')}</label>
                            <label className={'graph_label-period'}>{t('patientPage.Last_Days')}</label>
                        </div>
                        {/*{showDemo&&<PatientChart maxY={10} series={Targetseries} colors={['#005f7f', '#a8ae37', '#1d1d1b']}
                                       backgroundColor={'#ffffff'}
                                       minWidth={593} minHeight={235} showLegend={true}
                                       xCategories={categories2} stacked={false}/>}*/}
                        {showDemo&&<PatientChart series={Targetseries} colors={['#005f7f', '#a8ae37', '#1d1d1b']}
                                                 backgroundColor={'#ffffff'}
                                                 minWidth={593} minHeight={235} showLegend={true} maxY={10}
                                                 xCategories={categories} stacked={false}/>}

                    </div>
                    <div className={'Patient_Graph'}>
                        <div style={{display:'flex'}}>
                            <label className={'graph_label'}>{t('patientPage.Side_Effects')}</label>
                            <label className={'graph_label-period'}>{t('patientPage.Last_Days')}</label>
                        </div>
                        {showDemo&&<PatientChart series={SideEffectSeries} colors={['#005f7f', '#a8ae37', '#1d1d1b']}
                                       backgroundColor={'#ffffff'}
                                       minWidth={593} minHeight={235} showLegend={true} maxY={5}
                                       xCategories={categories2} stacked={false}/>}
                    </div>
                </div>

            </div>
)  :<div/>      )
    }
}

Patient_Page_TreatmentResponse.propTypes = {
    isDisabled: PropTypes.bool
}

export default Patient_Page_TreatmentResponse;

